module.exports = __webpack_public_path__ + "static/media/waiting.85a869ec.png";